import { Box, CircularProgress, IconButton, Tooltip, Typography } from '@material-ui/core';
import { BackIcon, CloseIcon, StyledDialog } from '@room-match/shared-ui-components';
import React, { useState } from 'react';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { useDispatch } from 'react-redux';
import { COLORS } from 'shared/constants/COLORS';
import { impersonate } from 'shared/redux/slicers/user.slicer';
import { useAppSelector } from 'shared/redux/store';
import { talentService } from 'shared/services/talentService';
import { ls } from 'shared/utils/ls';
import AddFamilyProfile from './AddFamilyProfile/AddFamilyProfile';
import AddMember from './AddMember/AddMember';
import {
  AddMemberButton,
  FamilyProfileCont,
  MainCont,
  MemberCont,
  MemberItemCont,
  MemberName,
  MemberPic,
} from './Guardianship.styles';

const { getTalentProfiles } = talentService();

const Guardianship: React.FC = () => {
  const dispatch = useDispatch();
  const { app: appState, user: userState } = useAppSelector((state) => state);
  const { isGuardian, members } = appState.guardian;
  const { setLS, getLS } = ls();
  const { data: profileData } = getTalentProfiles('', isGuardian.toString());
  const [showAddMember, setshowAddMember] = useState(false);
  const [showAddFamily, setshowAddFamily] = useState(false);
  const [impersonating, setimpersonating] = useState('');

  const impersonateTalent = (id: string) => {
    if (id === userState?.user?.id) return;
    setimpersonating(id);
    dispatch(impersonate(id));
  };

  const backToGuardian = () => {
    const guardianAccount = getLS('guardian_account');
    const guardianToken = getLS('guardian_token');
    setLS('auth_token', guardianToken);
    setLS('user', guardianAccount);
    window.location.reload();
  };

  return (
    <MainCont>
      {!isGuardian && localStorage.guardian_token && (
        <AddMemberButton
          style={{
            cursor: 'pointer',
          }}
          onClick={backToGuardian}
        >
          <BackIcon />
          <Typography style={{ textAlign: 'center' }}>Back to Guardian</Typography>
        </AddMemberButton>
      )}
      {isGuardian ? (
        <MemberCont>
          {members.map((t: any) => (
            <MemberItemCont
              onClick={() => impersonateTalent(t.id)}
              key={t.id}
              style={{
                cursor: t.id === userState?.user?.id ? 'not-allowed' : 'pointer',
                border: `solid 1px ${userState?.user?.id === t.id ? COLORS.PRIMARY : 'unset'}`,
              }}
            >
              {impersonating === t.id ? (
                <CircularProgress />
              ) : (
                <React.Fragment>
                  <MemberPic src={t.picture || '/assets/user.png'} />
                  <MemberName>{t.stage_name || t.first_name + ' ' + t.last_name}</MemberName>
                  <Typography style={{ fontSize: 12, color: '#98a1ac', lineHeight: 1 }}>
                    {t.id === userState?.user?.id ? 'Guardian' : ''}
                  </Typography>
                </React.Fragment>
              )}
            </MemberItemCont>
          ))}

          <AddMemberButton onClick={() => setshowAddMember(true)}>
            <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <AiOutlineUserAdd size={45} color={COLORS.PRIMARY} />
              <MemberName>Add Member</MemberName>
            </Box>
          </AddMemberButton>
        </MemberCont>
      ) : (
        <></>
      )}
      <FamilyProfileCont className="family-profile-cont">
        {profileData?.data?.profiles
          .filter((f) => f.is_group_profile)
          .map((p) => (
            <MemberItemCont style={{ width: 200 }} key={p.id}>
              <MemberPic style={{ width: 150 }} src={p.primary_medium_attachment?.attachment || '/assets/user.png'} />
              <MemberName>{p.group_name}</MemberName>
            </MemberItemCont>
          ))}
        {isGuardian ? (
          <Tooltip title="Coming Soon" placement="top" PopperProps={{ style: { marginBottom: -10 } }}>
            <div style={{ opacity: 0.5 }}>
              <AddMemberButton
                disabled
                onClick={() =>
                  profileData?.data.profiles.filter((f) => f.is_group_profile).length ? {} : setshowAddFamily(true)
                }
                style={{ marginRight: 0 }}
              >
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <HiOutlineUserGroup size={45} color={COLORS.PRIMARY} />
                  <MemberName style={{ width: 100, whiteSpace: 'break-spaces' }}>
                    {profileData?.data.profiles.filter((f) => f.is_group_profile).length
                      ? 'Edit Family Profile'
                      : 'Add Family Profile'}
                  </MemberName>
                </Box>
              </AddMemberButton>
            </div>
          </Tooltip>
        ) : (
          <></>
        )}
      </FamilyProfileCont>
      {showAddMember && (
        <AddMember
          disableProfile={!!members.filter((f: any) => f.id === userState?.user?.id).length}
          open={showAddMember}
          close={() => setshowAddMember(false)}
        />
      )}
      {showAddFamily && (
        <StyledDialog
          open={showAddFamily}
          onClose={() => setshowAddFamily(false)}
          maxWidth={false}
          aria-labelledby="simple-dialog-title"
        >
          <Box style={{ overflow: 'auto', position: 'relative', display: 'flex', flexDirection: 'column' }}>
            <IconButton
              style={{ width: 40, height: 40, margin: '10px 10px 10px auto' }}
              onClick={() => setshowAddFamily(false)}
            >
              <CloseIcon style={{ height: 16, width: 16 }} />
            </IconButton>
            <Box
              style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                padding: 20,
                height: '100%',
                overflow: 'auto',
              }}
            >
              <AddFamilyProfile close={() => setshowAddFamily(false)} />
            </Box>
          </Box>
        </StyledDialog>
      )}
    </MainCont>
  );
};

export default React.memo(Guardianship);
